import {
    getClessonsStatuses,
    GetClessonsStatusesResponse,
} from '@yandex-int/k-common/client/api/defs/get-clessons-statuses';
import { reportMessage } from 'platform-components/src/utils/raven-message';
import { all, call, put, takeEvery } from 'redux-saga/effects';

import { clessonsActions } from './actions';

export function* clessonsSagasWatcher() {
    yield all([takeEvery(clessonsActions.getClessonStatusesRequest, getClessonStatusesSaga)]);
}

function* getClessonStatusesSaga(action: ReturnType<typeof clessonsActions.getClessonStatusesRequest>) {
    const { clessonIds } = action.payload;
    try {
        const result: GetClessonsStatusesResponse = yield call(getClessonsStatuses, { clessonIds });
        yield put(clessonsActions.getClessonStatusesSuccess({ clessonStatuses: result }));
    } catch (error) {
        reportMessage('getClessonStatusesSaga error', error);
    }
}
